













import { Component, Prop, Vue } from 'vue-property-decorator';
import { Location } from 'vue-router';

@Component
export default class NavItem extends Vue {
    @Prop({ type: String, required: true })
    private title!: string;

    @Prop({ type: Object, required: true })
    private to!: Location;

    @Prop({ type: String, required: true })
    private activeImage!: string;

    @Prop({ type: String, required: true })
    private inactiveImage!: string;

    @Prop({ type: Boolean, required: false, default: false })
    exact!: boolean;
}
